
import { Component, OnInit } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { WebSiteService } from '../services/website-service';
import { ActivatedRoute } from '@angular/router';
import { SearchResultModel } from '../model/search-result.model';
import { DomSanitizer } from '@angular/platform-browser';
import { SearchPageShowModel } from '../model/search-page.model';

@Component({
    selector: 'm-search-page',
    templateUrl: './search-page.component.html',
    styleUrls: ['./search-page.component.scss']
})
export class SearchPageComponent implements OnInit {
    searchResults: SearchResultModel[];
    public searchData: SearchPageShowModel;

    constructor(
        public service: WebSiteService,
        private activeRouter: ActivatedRoute,
        private cd: ChangeDetectorRef,
        public sanitization: DomSanitizer
    ) {
        this.activeRouter.queryParams.subscribe(params => {
            const keys = params['keys'];

            this.service.getSearchPage().subscribe(result => {
                this.searchData = result.data;
                this.cd.detectChanges();
              });

            this.service.getSearchResult(keys).subscribe(result => {
                this.searchResults = result.data;

                this.cd.detectChanges();
            });
        });
    }

    ngOnInit(): void {

    }
}
